import { useStorage } from "@vueuse/core";

// Single shared ref for the onboarding storage key. Both useUserData and
// useOnboarding import THIS rather than each calling useStorage(...) — separate
// @vueuse refs on the same key don't sync in-tab, so independent writes would
// clobber each other (regress `boarded`, or wipe `checklistDismissedAt`).
export const boardedStorage = useStorage("nibOnlineSubmissions_boarded", {
  boarded: false,
  checklistDismissedAt: null as string | null,
});
